import React, { useEffect, useState } from "react";
import Filter from "./components/Filter";
import Select from "common/components/Select";
import { LuBedDouble } from "react-icons/lu";
import { BiBath } from "react-icons/bi";
import { TbLayersIntersect } from "react-icons/tb";
import { toast } from "react-toastify";
import axios from "common/configs/axiosConfigs";
import { SORT_OPTIONS } from "common/constants/enums";
import { useNavigate } from "react-router-dom";
import Modal from "common/components/Modal";

const Properties = () => {
  const companyId = JSON.parse(localStorage.getItem("user-auth")).company_id;
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [filter, setFilter] = useState({
    sort: "new",
    propertyType: "",
    location: "",
    minBudget: "",
    maxBudget: "",
    furnished: "",
    bedroom: "",
  });
  const [properties, setProperties] = useState([]);
  const [deletePropertyId, setDeletePropertyId] = useState(null);

  const onClose = () => {
    setIsOpen(false);
  };
  const handleFilter = ({ target: { name, value } }) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };
  const getProperties = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getProperty",
        companyId,
        ...filter,
      });
      if (data?.success) {
        setProperties(data?.data);
        onClose();
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getProperties();
  }, [filter.sort]);
  const onCancelDelete = () => {
    setIsOpen(false);
  };
  const onCancelDeleteProperty = () => {
    setDeletePropertyId(null);
  };
  const handleDeleteProperty = async () => {
    try {
      const { data } = await axios.post("", {
        action: "deleteProperty",
        companyId,
        propertyId: deletePropertyId,
      });
      if (data?.success) {
        toast.success(data?.msg);
        setProperties((prev) => prev.filter((prop) => prop.id !== deletePropertyId));
        setDeletePropertyId(null);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <section>
      <div className="container">
        <div className="row align-items-center mb-4">
          <h4>
            Properties{" "}
            <span className="text-muted" style={{ fontSize: 16 }}>
              ({properties?.length})
            </span>
          </h4>
          <div className="actions-cover d-flex ms-auto">
            <Select
              options={SORT_OPTIONS}
              name="sort"
              value={filter.sort}
              onChange={handleFilter}
            />
            <button type="button" className="btn btn-dark ms-3" onClick={() => setIsOpen(true)}>
              <i className="bi bi-funnel"></i>
            </button>
          </div>
        </div>
        <div className="row gy-4">
          {properties?.length ? (
            properties.map((p, i) => (
              <div className="col-lg-3 col-md-6" key={p?.id}>
                <div className="card overflow-visible property-card">
                  <div className="theme-img property-img n-mtx-3">
                    <button type="button" className={`wish-list-btn ${i === 2 ? "active" : ""}`}>
                      <i className="bi bi-heart"></i>
                    </button>
                    <img src={p?.property_thumbnail} alt="property1" />
                    <span className="property-type-badge">{p?.property_type_name}</span>
                    {p?.property_number && (
                      <span
                        className="property-type-badge bg-warning border-light text-white"
                        style={{ top: 32 }}
                      >
                        {p?.property_number}
                      </span>
                    )}
                  </div>

                  <div className="property-details position-relative">
                    <span className="property-badge">For {p?.sale_type}</span>
                    <h5>{p?.property_title}</h5>
                    <p className="text-muted mb-2">{p?.property_address}</p>
                    <span className="price mb-2 d-block">
                      ₹{p?.monthlyRent}
                      {p?.sale_type !== "sale" && (
                        <span className="sub-text text-dark">/month</span>
                      )}
                    </span>
                    <div className="d-flex property-features">
                      {p?.property_type === 1 && (
                        <span>
                          <LuBedDouble /> {p?.bedroom}
                        </span>
                      )}
                      <span>
                        <BiBath /> {p?.bathroom}
                      </span>
                      <span>
                        <TbLayersIntersect /> {p?.cover_area} Sq.Ft
                      </span>
                    </div>
                    <a
                      href={`https://jagahdekho.techtracesolution.com/property-details/${p?.id}`}
                      className="btn btn-dark w-100 mt-3"
                      target="_blank"
                    >
                      <i className="bi bi-box-arrow-up-right me-2"></i>View on Site
                    </a>
                    <div className="row mx-0 gap-1">
                      <button
                        type="button"
                        className="btn btn-success w-100 mt-1 col"
                        onClick={() => navigate(`/property/${p?.id}`)}
                      >
                        <i className="me-2 bi bi-pencil-square"></i>Edit
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger w-100 mt-1 col"
                        onClick={() => setDeletePropertyId(p?.id)}
                      >
                        <i className="me-2 bi bi-trash3"></i>Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <h3 className="mx-auto mt-5">No Property Found</h3>
          )}
        </div>
      </div>
      <Modal
        {...{
          isOpen: deletePropertyId,
          onClose: onCancelDeleteProperty,
          title: "Confirmation",
          size: "sm",
        }}
      >
        <>
          <p>Are you sure you want to delete?</p>
          <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
            <button type="button" className="btn btn-light me-2" onClick={onCancelDeleteProperty}>
              No
            </button>
            <button type="submit" className="btn btn-primary" onClick={handleDeleteProperty}>
              Yes
            </button>
          </div>
        </>
      </Modal>
      <Filter {...{ onClose, isOpen, handleFilter, filter, getProperties }} />
    </section>
  );
};

export default Properties;
